module.exports = __webpack_public_path__ + "img/produkt-brambory-krajene.1bc7eb06.jpg";